import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { AboutPage } from './routes/AboutPage';
import { HomePage } from './routes/HomePage';
import { DeleteAccountPage } from './routes/DeleteAccountPage';
import { LegalPage } from './routes/LegalPage';
import { PhonePaymentsPage } from './routes/PhonePaymentsPage';
import { VendorsPage } from './routes/VendorsPage';
import './styles/global.css';

export function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/payments" element={<PhonePaymentsPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/vendors" element={<VendorsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
